/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Customer-funded WhatsApp billing snapshot.
 */
export type WhatsAppCustomerManagedBilling = {
    /**
     * Customer pays Meta directly.
     */
    mode: WhatsAppCustomerManagedBilling.mode;
};
export namespace WhatsAppCustomerManagedBilling {
    /**
     * Customer pays Meta directly.
     */
    export enum mode {
        CUSTOMER_MANAGED = 'customer_managed',
    }
}

